const welcome =
`# Welcome!

> To get started, please select a **Boilerplate** or press \`CLEAR\` and start typing, or take the \`Tutorial\` above.

## What is Markdown?

> Markdown is a lightweight markup language with plain text formatting syntax. Markdown is often used to format readme files, to write messages in online discussion forums, and to create rich text using a plain text editor.

> Markdown is easily converted to HTML.

### For more information, please see:

- [https://en.wikipedia.org/wiki/Markdown](https://en.wikipedia.org/wiki/Markdown)

- [https://help.github.com/articles/basic-writing-and-formatting-syntax](https://help.github.com/articles/basic-writing-and-formatting-syntax)

`
export {welcome}



// WEBPACK FOOTER //
// ./src/boilerplates/welcome.js